module.exports = __webpack_public_path__ + "static/media/img3.4ccc344a.jpg";